export const UPDATE_SPOT_SCREENSHOT = 'UPDATE_SPOT_SCREENSHOT'

export function screenshotImageSpotReducer(state = "", action) {
    switch (action.type){
        case UPDATE_SPOT_SCREENSHOT:
            return action.payload
        default: return state
    }
}